import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import DialogPopup from '../../../Popup/Dialog/DialogPopupLayout';
import FormTabs from '../../../Tabs/FormTabs';
import { FolderType } from '../../redux/types';
import MobileTitle from './MobileTitle';
import FolderList from '../FolderList';
import GroupsList from '../GroupsList';
import s from './MobileLayout.scss';
export var MobileLayout = function (_a) {
    var selectedGroup = _a.selectedGroup, deviationId = _a.deviationId, onClose = _a.onClose, selectedSubmissionType = _a.selectedSubmissionType, onSubmissionTypeSelected = _a.onSubmissionTypeSelected, onResetSelectedGroup = _a.onResetSelectedGroup, onFolderSelected = _a.onFolderSelected, onGroupSelected = _a.onGroupSelected;
    var t = useTranslation().t;
    var items = [
        {
            index: FolderType.Gallery,
            labelTransKey: 'addToGroup.folderType.gallery',
        },
        {
            index: FolderType.Collection,
            labelTransKey: 'addToGroup.folderType.collection',
        },
    ];
    var listHeader = (React.createElement(React.Fragment, null,
        selectedGroup && (React.createElement("div", { className: s['header-extras'] },
            React.createElement(FormTabs, { items: items, activeIndex: selectedSubmissionType, className: s['tabs'], onChange: onSubmissionTypeSelected }))),
        React.createElement("div", { className: s['subheader'] }, t(selectedGroup
            ? 'addToGroup.chooseAnyFolder'
            : 'addToGroup.chooseAnyGroup'))));
    return (React.createElement(DialogPopup, { title: React.createElement(MobileTitle, { selectedGroup: selectedGroup, onResetSelectedGroup: onResetSelectedGroup }), headerClassName: classnames(s['header'], selectedGroup && s['with-tabs']), rootClassName: s['root'], onClose: onClose, withCloseButton: true, isOpen: true },
        React.createElement("div", { className: s['content'] }, selectedGroup ? (React.createElement(FolderList, { key: selectedSubmissionType, headerContent: listHeader, deviationId: deviationId, groupId: selectedGroup.userId, submissionType: selectedSubmissionType, onFolderSelected: onFolderSelected })) : (React.createElement(GroupsList, { headerContent: listHeader, onGroupSelected: onGroupSelected, scrollableWrapperClassName: s['groups-list-scrollable'] })))));
};
export default MobileLayout;
//# sourceMappingURL=MobileLayout.js.map